// Types

// Context
export {
	AudienceModalProvider,
	useAudienceModalContext,
} from "../../providers/AudienceModalContext";
export { default as AudienceModalActions } from "./AudienceModalActions";
export { default as AudienceModalBody } from "./AudienceModalBody";
// Individual components
export { default as AudienceModalComposer } from "./AudienceModalComposer";
export { default as AudienceModalContainer } from "./AudienceModalContainer";
export { default as AudienceModalFilters } from "./AudienceModalFilters";
export { default as AudienceModalHeader } from "./AudienceModalHeader";
export { default as AudienceModalResults } from "./AudienceModalResults";
export type {
	AudienceModalComposerProps,
	AudienceModalContextValue,
	AudienceModalProviderProps,
	AudienceModalSection,
} from "./AudienceModalTypes";

// Composed components
import { AudienceModalProvider } from "../../providers/AudienceModalContext";
import AudienceModalActions from "./AudienceModalActions";
import AudienceModalBody from "./AudienceModalBody";
import AudienceModalComposer from "./AudienceModalComposer";
import AudienceModalContainer from "./AudienceModalContainer";
import AudienceModalFilters from "./AudienceModalFilters";
import AudienceModalHeader from "./AudienceModalHeader";
import AudienceModalResults from "./AudienceModalResults";

// Main AudienceModal object with dot notation API
const AudienceModal = {
	Provider: AudienceModalProvider,
	Composer: AudienceModalComposer,
	Container: AudienceModalContainer,
	Header: AudienceModalHeader,
	Body: AudienceModalBody,
	Filters: AudienceModalFilters,
	Results: AudienceModalResults,
	Actions: AudienceModalActions,
};

export default AudienceModal;
